var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61 5.634a4.636 4.636 0 1 1 9.27 0v5.426a4.636 4.636 0 0 1-9.27 0V5.634Zm4.635-3.386A3.386 3.386 0 0 0 8.86 5.634v.264h2.283v1.25H8.86v1.973h2.283v1.25H8.86v.689a3.386 3.386 0 0 0 6.772 0V5.634a3.386 3.386 0 0 0-3.386-3.386Zm.926 19.504h1.68v1.25H10.24v-1.25h1.68V18.27a7.098 7.098 0 0 1-6.772-7.09v-.883h1.25v.883a5.847 5.847 0 1 0 11.695 0v-.883h1.25v.883a7.099 7.099 0 0 1-6.172 7.038v3.534Z",
    fill: "currentColor"
  })));
};
export default SvgMic;